import { render, staticRenderFns } from "./McrFormA4.vue?vue&type=template&id=0957e973"
import script from "./McrFormA4.vue?vue&type=script&lang=js"
export * from "./McrFormA4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports